import AddCategoryAccordian from "./categoryList";

const BannerText = () => {
  return (
    <div className="banner-text-container">
      <AddCategoryAccordian />
    </div>
  );
};

export default BannerText;
